<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#68D389"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDAC53" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left align-self-center>{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pt-4>
      <v-flex >
        <v-tabs  fixed-tabs v-model="tabValue" color="#FDAC53" centered slider-color="yellow">
          <v-tab
            v-for="item in titleArray"
            @click="getPrograms(item.value)"
            :key="item.value"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </v-flex>
    </v-layout>
    <v-tabs-items v-model="tabValue">
      <template v-for="(item, index) in titleArray">
        <v-tab-item :key="item.value" :value="index">
          <v-layout wrap>
            <v-flex xs12  >
              
          <Programs :Name="item.value" @stepper="winStepper"></Programs>
            </v-flex>
          </v-layout>
        </v-tab-item>
      </template>
    </v-tabs-items>
  </div>
</template>
<script>
import axios from "axios";
import Programs from "./editStaticPagesOnly";
export default {
  components: {
    Programs,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      categories: [],
      programs: [],
      tabValue: 0,
      // titleArray: [
      //   { title: "Learn about the Reserve", value: "Learn about the Reserve" },
      //   { title: "Policies", value: "Policies" },
      //   { title: "Get Involved", value: "Terms and Conditions" },
      //   { title: "Page Contributor", value: "Page Contributors" },
      //   // { title: "COTTAGES", value: "cottage" },
      // ],
      titleArray: [
        { title: "Travel and Cancellation Policy", value: "Travel and Cancellation Policy" },
        { title: "Privacy Policy", value: "Privacy Policy" },
        { title: "Terms and Conditions", value: "Terms and Conditions" },
        { title: "Indemnity Bond", value: "Indemnity Bond" },
        // { title: "Page Contributor", value: "Page Contributors" },
        // { title: "COTTAGES", value: "cottage" },
      ],
    };
  },
  beforeMount() {
    this.getPrograms("started");
    // this.getCategories();
  },
  methods: {
    // winStepper(window_data) {
    //   if (window_data.response) this.slotAddition = window_data.slotAddition;
    //   this.packageRate = window_data.response;
    // },
    winStepper(windowData) {
      if (windowData.response.status) {
        this.msg = "Delete Sucessfully";
        this.showSnackbar = true;
        this.getPrograms("started");
        //   this.data=windowData.name
        // console.log(windowData);
      }
      //  else this.date = windowData.date;
    },
    getPrograms(val, catid) {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/programme/getlist",
        params: { programmestatus: val, category: catid, isCottage: false },
      })
        .then((response) => {
          this.appLoading = false;
          this.programs = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    deleteItem(cat) {
      var data = {};
      data["id"] = cat._id;
      axios({
        url: "/programme/remove",
        method: "POST",
        data: data,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.delete = false;
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Delete Sucessfully";
            this.showsnackbar = true;

            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>